import { Link as GatsbyLink } from 'gatsby';
import BigCenteredBtn from "../../../../src/components/layout-pieces/big-centered-btn";
import React from 'react';
export default {
  GatsbyLink,
  BigCenteredBtn,
  React
};